import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import useConnectModal from 'components/ConnectModal';
import { authAccountWithIntegration } from 'utils/integrations';
import ConnectImage from 'assets/images/connected.svg';
import GmailImage from 'assets/images/gmail.svg';
import iCloudImage from 'assets/images/icloud.svg';
import MicrosoftImage from 'assets/images/microsoft.svg';

const IntegrationCard = () => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const { integrations, integrationDeleting } = userInfo;

  const {
    setConnectModalOpen,
    setConfirmModalOpen,
    integrationsNonVirtual,
    setErrorModal,
    ConnectModal,
  } = useConnectModal();


  const integrationsNonExpired = useMemo(() => {
    return integrationsNonVirtual.filter(int => int.grantStatus !== 'expired');
  }, [integrationsNonVirtual]);

  const isConnected = integrationsNonExpired && integrationsNonExpired.length > 0;

  // TODO: At some point we should address integrations via their id.
  // For now, we're just going to assume that there's only one integration.
  // Relevant variables:
  // - integrations
  // - integrationDeleting
  // - integrationsNonVirtual
  // - isIntegrationDeleting
  const isIntegrationDeleting = Object.values(integrationDeleting).some(value => value);

  const handleIntegrationConnect = () => {
    // Connect a new account.
    if (!integrationsNonVirtual || integrationsNonVirtual.length < 1) {
      setConnectModalOpen(true);
      return;
    }

    // Re-integration an existing account.
    const expiredIntegration = integrations.find(int => int.grantStatus === 'expired');
    if (expiredIntegration) {
      const { provider, email } = expiredIntegration;
      authAccountWithIntegration({ provider, loginHint: email }, setErrorModal);
    }
  };

  const getProviderImage = (provider) => {
    switch (provider) {
      case 'google':
        return GmailImage;
      case 'icloud':
        return iCloudImage;
      case 'microsoft':
        return MicrosoftImage;
      default:
        return false;
    }
  };

  return (
    <>
      <div className="integration">
        <div className="integration__image calendar">
          <img src={ConnectImage} />
        </div>
        <div className="integration__content">
          <h5 className="integration__title">AP CONNECT</h5>
          <p>
            Power up your Aisle Planner Pro account with email integration, two-way external
            calendar sync and easy-to-use scheduling tools, all behind one powerful integration.
            <br />
            <a href="https://help.aisleplanner.com/en/collections/11625100-ap-connect"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>.
          </p>
          {integrationsNonVirtual.length ? (
            <div className={clsx('connected-provider', integrationsNonVirtual[0].provider)}>
              <img src={getProviderImage(integrationsNonVirtual[0].provider)} />
              <span>Your connected calendar/email: <strong>{integrationsNonVirtual[0].email}</strong></span>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setConfirmModalOpen(true);
                }}
                disabled={isIntegrationDeleting}
              >
                Disconnect
              </a>
            </div>
          ) : null}
        </div>
        <div className="integration__actions">
          <button
            className={clsx('button', (isIntegrationDeleting || isConnected) && 'button--connected')}
            onClick={handleIntegrationConnect}
          >
            {
              isIntegrationDeleting ?
                'Loading...' :
              integrationsNonVirtual.length ?
                'Connected' : 'Connect'
            }
          </button>
        </div>
      </div>
      <ConnectModal />
    </>
  );
};

export default IntegrationCard;
